export default {
    header: 'Top\u00A03 carriers in the direction ',
    description: {
        one: 'We have highlighted the carrier\nwho will be most interested in your load.',
        count: 'We have highlighted {{count}} carriers\nwho will be most interested in your load.',
        default: 'We have highlighted the carriers\nwho will be most interested in your load.',
    },
    ask: 'Please share your opinion',
};
